/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Step_Label_UserInputs */

const es_co2_signup_step_label_user = /** @type {(inputs: Signup_Step_Label_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información`)
};

/**

* @param {Signup_Step_Label_UserInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const signup_step_label_user = /** @type {((inputs?: Signup_Step_Label_UserInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Step_Label_UserInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_signup_step_label_user(inputs)
});